const Language = ( props ) => {

  return (
    <img
        className="p-2 border-2 rounded-xl aspect-square object-contain
                   sm:max-h-16
                   border-zinc-900 dark:border-zinc-100
                   sm:hover:bg-zinc-900 sm:dark:hover:bg-zinc-100
                   sm:hover:scale-110 transition-all"
        src={`/${props.language}.png`}
        onClick={props.onClick}/>
  );

};

export default Language;
